import styled from 'styled-components';
import {Link} from 'react-router-dom';
import {mobileMedia} from '../../../../../../../globalVariables/GlobalVariables';
import {tokens} from '@tickchak/react-share/app';
import {dFlex, alignCenter, flexWrap} from '../../../../../../../globalVariables/GlobalFlex';

export const header = styled.div`
  ${dFlex}
  ${alignCenter}
  ${flexWrap}
  row-gap: var(--space-lg);
  column-gap: var(--space-xl);
  ${mobileMedia}{ direction: rtl; }
`;
export const title = styled.div`
  font-size: ${tokens.typography.fontSize.h3};
  font-weight: ${tokens.typography.fontWeight.regular};
  line-height: ${tokens.typography.lineHeight.h3};
  text-align: start;
  white-space: nowrap;
  ${mobileMedia}{ flex-basis: 100%; }
`;
export const controls = styled.div`
  display: contents;
  ${mobileMedia}{
    ${dFlex}
    ${alignCenter}
    ${flexWrap}
    flex-basis: 100%;
    justify-content: center;
    gap: var(--space-md);
  }
`;
export const toolbar = styled.div`
  ${dFlex}
  ${alignCenter}
  min-width: 0;
  order: 1;
`;
export const manageBtn = styled(Link)`
  ${dFlex}
  ${alignCenter}
  gap: var(--space-sm);
  height: 32px;
  background: var(--TA-color-brand-main);
  color: var(--TA-color-text-default);
  border: none;
  border-radius: var(--radius-full);
  padding: 0 var(--space-lg);
  font-size: ${tokens.typography.fontSize.bodySmall};
  font-weight: ${tokens.typography.fontWeight.bold};
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  order: 2;
  margin-inline-start: auto;
  margin-inline-end: 48px;
  ${mobileMedia}{
    margin-inline-start: 0;
    margin-inline-end: 0;
  }
`;
